import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useLanguage } from "./i18n";

// Setzt pro Seite Title, Description, OpenGraph und Canonical.
// Die URL kommt aus der tatsächlichen Adresse (DE oder EN).
export const SITE_URL = "https://wimjansen.de";

// Englische Meta-Texte je Adresse
const EN_META = {
  "/en": {
    title: "Wim Jansen Delgado · Restaurant, hotel and travel photographer, Hamburg",
    description:
      "Wim Jansen Delgado is a photographer based in Hamburg, specialised in restaurants, hotels and travel. Found, not staged.",
  },
  "/en/projects": {
    title: "Projects · Wim Jansen Delgado · Photographer Hamburg",
    description: "Selected series and projects by Wim Jansen Delgado, photographer based in Hamburg.",
  },
  "/en/fieldnotes": {
    title: "Fieldnotes · Wim Jansen Delgado · Photographer Hamburg",
    description: "Notes from the road: quiet moments, found rather than staged, by Wim Jansen Delgado.",
  },
  "/en/about": {
    title: "About · Wim Jansen Delgado · Photographer based in Hamburg",
    description:
      "Wim Jansen Delgado photographs for Michelin restaurants, hotels and magazines: unposed, honest, always looking for the quiet moment.",
  },
  "/en/contact": {
    title: "Contact · Wim Jansen Delgado · Photographer Hamburg",
    description:
      "Enquiries for restaurant, hotel, travel and portrait photography. Wim Jansen Delgado, Hamburg.",
  },
};

const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

export const useSeo = ({ title, description, robots }) => {
  const { lang } = useLanguage();
  const { pathname } = useLocation();
  useEffect(() => {
    const en = lang === "en" ? EN_META[pathname] : null;
    const finalTitle = en ? en.title : title;
    const finalDescription = en ? en.description : description;
    const url = `${SITE_URL}${pathname}`;
    document.title = finalTitle;
    setMeta("name", "description", finalDescription);
    setMeta("property", "og:title", finalTitle);
    setMeta("property", "og:description", finalDescription);
    setMeta("property", "og:url", url);
    setMeta("name", "twitter:title", finalTitle);
    setMeta("name", "twitter:description", finalDescription);
    setMeta("name", "robots", robots || "index, follow");
    const canonical = document.head.querySelector('link[rel="canonical"]');
    if (canonical) canonical.setAttribute("href", url);
  }, [title, description, pathname, lang, robots]);
};
